$(document).ready(() => {
  $(".js-open-cart").click(function (e) {
    on();
    $(".cart-wrapper").addClass("active");
    e.preventDefault();

    async function getLocation() {
      let url =
        "https://" +
        window.location.hostname +
        "/browsing_context_suggestions.json";
      let obj = await (await fetch(url)).json();
      let country = obj.detected_values.country.handle;
      let btnContainer = document.getElementById("btn-container");
      let beautycircleDetail = document.getElementById("beautycircle-detail");

      if (country === "NZ" && btnContainer.childNodes.length === 1) {
        let btn = document.createElement("button");
        btn.addEventListener("click", function (event) {
          CartJS.addItem(39601154949281);
        });
        btn.className = "nz-shipping-addtocart";
        btn.innerHTML = "Add to Cart";
        btnContainer.appendChild(btn);

        let detail = document.createElement("div");
        detail.innerHTML = "- free return shipping label for NZ.";
        beautycircleDetail.appendChild(detail);
      }

      if (country === "AU" && btnContainer.childNodes.length === 1) {
        let btn = document.createElement("button");
        btn.addEventListener("click", function (event) {
          CartJS.addItem(40907613798561);
        });
        btn.innerHTML = "Add to Cart";
        btnContainer.appendChild(btn);

        let detail = document.createElement("div");
        detail.innerHTML = "- free return shipping label for AU.";
        beautycircleDetail.appendChild(detail);
      }
    }

    getLocation();
  });

  $(".js-close-cart").click(function (e) {
    off();
    $(".cart-wrapper").removeClass("active");
    e.preventDefault();
  });

  /* Open Device Menu */
  var mobileMenuTl = gsap.timeline({
    paused: true,

    onStart: function () {
      $(".mobile-menu").addClass("active");
      $("body").addClass("menu-open");
    },

    onReverseComplete: function () {
      $(".mobile-menu").removeClass("active");
      $("body").removeClass("menu-open");
    },
  });

  mobileMenuTl.fromTo(
    ".mobile-menu",
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    }
  );

  mobileMenuTl.fromTo(
    ".mobile-menu .nav-links > a",
    {
      autoAlpha: 0,
      x: 15,
    },
    {
      autoAlpha: 1,
      x: 0,
      duration: 0.3,
      stagger: 0.1,
    }
  );

  $(".mobile-menu-button").click(function (e) {
    e.preventDefault();
    mobileMenuTl.play();
  });

  $(".close-mobile-menu").click(function (e) {
    e.preventDefault();
    mobileMenuTl.reverse();
  });

  $("#select-option1").change(() => {
    $(".js-variant-id").val($("#select-option1").val());
    $("button#add-to-cart-button").prop("disabled", false);
  });

  /* Show Beauty Circle label on hover (Cart) */
  $(".detail").hover(
    function () {
      $(".beauty-circle-label-wrapper").show();
    },
    function () {
      $(".beauty-circle-label-wrapper").hide();
    }
  );

  function on() {
    document.getElementById("overlay").style.display = "block";
    document.body.style.overflowY = "hidden";
  }
  function off() {
    document.getElementById("overlay").style.display = "none";
    document.body.style.overflowY = "auto";
  }

  var current = location.pathname;
  var root = "/";
  if (
    "Shopify" in window &&
    "routes" in window.Shopify &&
    "root" in window.Shopify.routes
  ) {
    root = window.Shopify.routes.root;
    if (root !== "/") {
      root = root.replace(/\/$/, "");
    }
  }

  if (current !== root && current !== root + "#" && current !== root + "/!") {
    $("nav li a").each(function () {
      var $this = $(this);
      var href = $this.attr("href");

      if (href && href.indexOf("/blogs/skin-academy") !== -1) {
        return;
      }

      if (href && href.indexOf(current) !== -1) {
        $this.addClass("active");
      }
      if (current === root + "pages/our-story") {
        $('a.nav-link[href="/pages/about"]').addClass("active");
      }
      if (current === root + "collections/all") {
        $('a.nav-link[href="' + root + 'collections/all"]').addClass("active");
      }
    });

    var currentFullUrl = current + window.location.search;

    $("a[href*='/blogs/skin-academy']").each(function () {
      var $this = $(this);
      var href = $this.attr("href");

      $this.removeClass("active");

      // Check if we're on any skin-academy page and this is the main skin academy link
      if (
        current === "/blogs/skin-academy" &&
        (href === "/blogs/skin-academy" || href === "#")
      ) {
        $this.addClass("active");
      }
      // Check for exact match (for subpages or specific links)
      else if (href === currentFullUrl) {
        $this.addClass("active");
      }
    });
  }

  // if (current !== root && current !== root + "#" && current !== root + "/!") {
  //   $("nav li a").each(function () {
  //     var $this = $(this);
  //     // if the current path is like this link, make it active
  //     if ($this.attr("href").indexOf(current) !== -1) {
  //       // $this.css('text-decoration', 'underline');
  //       $this.addClass("active");
  //     }
  //     if (current === root + "pages/our-story") {
  //       // $('a.nav-link[href="/pages/about"]').css('text-decoration', 'underline');
  //       $('a.nav-link[href="/pages/about"]').addClass("active");
  //     }
  //     if (current === root + "collections/all") {
  //       // $('a.nav-link[href="/pages/about"]').css('text-decoration', 'underline');
  //       $('a.nav-link[href="' + root + 'collections/all"]').addClass("active");
  //     }
  //   });
  // }

  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    jQuery(".cart-footer .gradient").each(function () {
      jQuery(this).attr("id", "safari");
    });
  }

  $(".search-results").hide();

  var searchObj = document.querySelector(".search__input");
  searchObj.oninput = function () {
    // console.log(this.value);
    var keyWord = this.value;
    document.querySelector(
      ".search-results__products .search-results__all"
    ).href = `/search?q=${keyWord}*&type=product`;
    document.querySelector(
      ".search-results__articles .search-results__all"
    ).href = `/search?q=${keyWord}*&type=article`;

    if (keyWord.trim() == "") {
      $(".search-results").fadeOut();
    } else {
      $(".search-results").fadeIn();

      $.ajax({
        url: `/search?q=${keyWord}*&type=product`,
        type: "GET",
        dataType: "html",
        success: function (data) {
          //console.log('data', data);
          var products = $("<div />")
            .append(data)
            .find("ul.page-width.list-view-items .product-grid > div");

          // ✅ FIX: safer filter (avoids undefined href errors)
          var newProducts = [];
          for (var i = 0; i < products.length; i++) {
            const href = $(products[i])
              .find("a.product-item__link")
              .attr("href");
            if (
              href &&
              href.indexOf("emma-lewisham-beauty-circle-shipping-label") === -1
            ) {
              newProducts.push(products[i]);
            }
          }

          //var totalResults = ($('<div />').append(data).find('span#results-total')).html();
          var totalResults = newProducts.length;

          var newHtml = "";
          var loop = parseInt(totalResults) < 3 ? parseInt(totalResults) : 3;
          if (products.length != 0) {
            for (var i = 0; i <= loop - 1; i++) {
              newHtml = newHtml + newProducts[i].outerHTML;
            }
            $(".search-results__products .product-grid").html(newHtml);

            // productHover(document.querySelector('.search-results__products .product-grid'));

            $(".search-results__products .search-results__heading h2").html(
              totalResults + " Results"
            );
          } else {
            document.querySelector(
              ".search-results__products .product-grid"
            ).innerHTML = "";
            $(".search-results__products .search-results__heading h2").html(
              totalResults + " Results"
            );
          }
        },
      });

      $.ajax({
        url: `/search?q=${keyWord}*&type=article`,
        type: "GET",
        dataType: "html",
        success: function (data) {
          var href = $("<div />")
            .append(data)
            .find("ul.page-width.list-view-items a.journal-item");
          var products = $("<div />")
            .append(data)
            .find("ul.page-width.list-view-items .journal-item .bottom");
          var totalResults = $("<div />")
            .append(data)
            .find("span#results-total")
            .html();
          var newHtml = "";
          var loop = parseInt(totalResults) < 3 ? parseInt(totalResults) : 3;
          if (products.length != 0) {
            for (var i = 0; i <= loop - 1; i++) {
              newHtml =
                newHtml +
                `<li>
    <a href="${$(href[i]).attr("href")}">
      ${$(products[i]).find(".title").html()}
      <span>
      ${$(products[i]).find(".date").html()}
      </span>
    </a>
  </li>`;
            }
            $("ul.search-articles__list").html(newHtml);
            $(".search-results__articles .search-results__heading h2").html(
              totalResults + " Results"
            );
          } else {
            document.querySelector("ul.search-articles__list").innerHTML = "";
            $(".search-results__articles .search-results__heading h2").html(
              totalResults + " Results"
            );
          }
        },
      });
    }

    // document.querySelector('.search-results__all').href = `/search?q=${keyWord}*&type=product`;
    // fetch(`/search/suggest.json?q=${keyWord}&resources[type]=product`)
    // .then((response) => response.json())
    // .then((suggestions) => {console.log(suggestions);
    // var products = suggestions.resources.results.products
    // document.querySelector('.search-results__heading h4').innerHTML = products.length + ' Results'
    // if(products.length != 0){
    //   console.log(products)
    //   var newHtml = ''
    //   for (var i = 0; i<= 3; i++){
    //     newHtml = newHtml + ` <div id="pro-div-${i}" class="product-item">
    //     <a href="${products[i].url?products[i].url: '#' }" id="pro${i}"></a>
    //     <div class="product-item-inner">
    //       <div class="product-img-container" onclick="window.location.href  = '${products[i].url?products[i].url: '#' }'">
    //         <img src="${products[i].image?products[i].image: '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif'}" class="product-img">
    //       </div>
    //     </div>
    //       <div class="product-item-metadata">
    //         <div class="meta-inner">
    //           <div class="left" onclick="window.location.href  = '${products[i].url?products[i].url: '#' }'">
    //             <div class="category">${products[i].type?products[i].type:''}</div>
    //             <div class="name">${products[i].title}</div>
    //           </div>
    //           <div class="right">
    //             <img src="//cdn.shopify.com/s/files/1/0569/2017/8855/t/17/assets/5-star.svg?v=10290860577614946070" alt="" class="rating">
    //             <img src="//cdn.shopify.com/s/files/1/0569/2017/8855/t/17/assets/5-star-white.svg?v=9708866807648020325" alt="" class="rating rating-white">
    //             <div class="price">
    //               <span class="amount">
    //                 <span class="money">$${products[i].price}</span>
    //               </span>
    //               <span class="hide add-to-cart">Out of stock</span>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //   </div>`
    //   }
    //   document.querySelector('.search-results__products .product-grid').innerHTML = newHtml
    // }else{
    //   document.querySelector('.search-results__products .product-grid').innerHTML = ''
    // }
    // });
  };
});
